import { Attributes, Misc, Model, Rules } from '@singularsystems/neo-core';

export default class TransactionRequest {

    public transactionRequestId: number = 0;

    @Rules.Required()
    public investorInvestmentId: number | null = null;

    @Rules.Required()
    public issuerInvestmentId: number | null = null;

    @Attributes.Float()
    public amount: number = 0;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public effectiveDate: Date | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public requestedDate: Date | null = new Date();

    public createdBy: number = 0;

    @Attributes.Date()
    public createdOn: Date = new Date();

    public cancelled: Model.UserEvent = Model.UserEvent.None();

    public isComplete: boolean = false;

    // Client only properties / methods
}